require('./myAnswer.less')
require('../../app/app');

var i18n = require('i18n');
var util = require('../../app/util');
var pageConfig = window.pageConfig || {};
var pagination = require('../../app/pagination');
var topicList = require('../../app/topicList.html');
var wrapper = require('../../app/main.html');




var App = {
  init: function() {
  	if (pageConfig.error) {
  		util.show(pageConfig.error, 'error');
  		return;
  	}
  	
  	pageConfig.login = true;
		$('body').append(wrapper(pageConfig));
		
		var reg = new RegExp(pageConfig.projectName + '\/(.+)\/answer');
		var id = parseInt(location.pathname.match(reg)[1], 10);
		var uid = util.getUid();
		


		$('.list-title').text(i18n('answered.topic'))
    var userAgent = window.navigator.userAgent || '';
    if (userAgent.match(/[bB]ot\//)  || userAgent.match('[sS]pider')) {
      return
    }
		pagination(`${pageConfig.projectName}/topic/myAnswerList?uid=${id}`, topicList, null, null, {
      showDelete: true
    });
  }
}

// Entry
;(function() {
  App.init();
})();







// WEBPACK FOOTER //
// ./src/pages/myAnswer/myAnswer.js